import { IBaseModel, BaseModel } from '../base.model';

export interface IBMCommentEditedViewModel extends IBaseModel {
  createTicket: boolean,
  deadline: string,
  description: string,
  medias: number[],
  subject: string
}
export class BMCommentEditedViewModel extends BaseModel implements IBMCommentEditedViewModel {
  createTicket: boolean
  deadline: string
  description: string
  medias: number[]
  subject: string

  constructor (createTicket: boolean = false,
               deadline: string = null,
               description: string = '',
               medias: number[] = [],
               subject: string = '') {
    super()
    this.createTicket = createTicket
    this.deadline = deadline
    this.description = description
    this.medias = medias
    this.subject = subject
  }
}



// WEBPACK FOOTER //
// ./src/models/bm/bm-comment-edited.viewmodel.ts